import { render, staticRenderFns } from "./detailMetaDialog.vue?vue&type=template&id=4dc76636&scoped=true&lang=pug"
import script from "./detailMetaDialog.vue?vue&type=script&lang=js"
export * from "./detailMetaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc76636",
  null
  
)

export default component.exports